export default __webpack_public_path__ + "static/media/medaille-qdo-bronze-conception.707bc025.png";